export const baseUrl = process.env.REACT_APP_BASE_URI;
export const divisionUrl = process.env.REACT_APP_DVS_URI;
export const changeTasksUrl = process.env.REACT_APP_CHANGE_TASKS_URI;
export const salesforceUrl = process.env.REACT_APP_SALESFORCE_URL;
export const apimSubscriptionKey = process.env.REACT_APP_OAUTH_SUBSCRIPTION_KEY
export const profilePictureUrl = process.env.REACT_APP_PROFILE_PICTURE_URL
